<template>
    <div class="container mt-5 pb-5" style="border-bottom: 1px solid #E0E0E0;">
        <v-app-bar
                v-if="$store && $store.getters"
                dense
                color="transparent"
                style="box-shadow: none !important;"
                class="my-header px-0 my-header"
        >

            <div>
                <p class="ma-0 fw-600 fs-36">{{$route.meta.name}}</p>
            </div>

            <v-spacer></v-spacer>


            <div class="ml-4 hover d-flex justify-center align-center" style="width: 48px; height: 48px; background-color: white; border-radius: 8px; box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);">
                <v-menu offset-y origin="center center"  open-on-hover  transition="scale-transition">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" text large >
                            <v-img class="hover" max-height="24px" max-width="24px" :src="$root.getSrc('default/drop_icons/user.svg')" contain></v-img>
                        </v-btn>
                    </template>
                    <v-list class="pa-0">
                        <v-list-item
                            v-for="(item, i) in menu_items"
                            :key="i"
                            @click="item.handler"
                        >
                            <v-list-item-icon>
                                <v-icon color="#2F80ED" v-text="item.icon"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="drop-blue" v-text="$t(item.name)"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>


            <v-icon class="ml-2 hover" @click="$store.commit('navigation/TOGGLE_SIDEBAR')">mdi-menu</v-icon>
        </v-app-bar>
    </div>
</template>
<script>
    import { mapGetters, mapActions} from 'vuex';
    import Notification from '../../components/notifications';
    import Autocomplete from './autocomplete';
    import util from '../../utilis';
    import SearchComponent from './search-component'
    import LangSwitcher from '../../components/lang-switcher';
    export default {
        components:{
          NotificationList: Notification,LangSwitcher,SearchComponent,
            Autocomplete
        },

        data(){
            return{
                menu_items:[
                    {
                        name: 'Edit account',
                        icon: 'mdi-account-edit',
                        handler: () => {this.$router.push('/user/edit')},
                    },
                    {
                        name: 'Log out',
                        icon: 'mdi-logout',
                        handler: () => {this.logout()},
                    }
                ]
            }
        },
        computed:{
            ...mapGetters([
                'user', 'notifications', 'activeWebsite', 'websites'
            ]),
            crumbs: function(){
                let breds = [];
                if(this.$route.meta.breadcrumbs){
                    breds = this.$route.meta.breadcrumbs;
                    breds.forEach(bred=>{
                        if(bred.title == 'Product Details'){
                            bred.to = bred.to + this.$route.params.id;
                        }
                    })
                }

                return breds;
            }
        },
        mounted(){
            if(this.$route.name == 'Color Swatch' || this.$route.name == 'Print Area'){
               // this.$route.meta.breadcrumbs[1].to = this.$route.meta.breadcrumbs[1].to + this.$route.params.id;
               // this.$forceUpdate();
            }
        },
        methods:{
          isTransparent(){
            if(this.$route.name == 'login' || this.$route.name == 'register') return true;
            return false;
          },
          setActiveWebsite(website){
              this.$store.dispatch('websites/setActive', website);
              location.reload();
          },
          toggleSidebar(){
            this.$store.dispatch('navigation/toggleSideBar');
          },
            toggleMini(){
                this.$store.dispatch('navigation/toggleMini');
            },
          fullScreen(){
           util.toggleFullScreen();
          },
          logout(){
              this.$store.dispatch('user/logout');
          }
        }
    }
</script>
<style lang="scss">
    .my-header{
        .v-toolbar__content{
            padding: 0px;
/*
            transition: all 300ms;
*/
        }
    }
    .breadcrumb{
        display: flex;
        .v-btn{
            &:before{
                display: none !important;
            }
            background-color: transparent !important;
        }
    }
    .searching{
        .v-toolbar__content{
            transform: translateX(-40px);
            width: 150%;
        }
    }

</style>
